import {
  FETCH_CENTRE_SUCCESS,
} from './actions';
import { Map } from 'immutable';
import Centre from './model';

export default function centreReducer(state = new Map(), action) {
  switch (action.type) {
    case FETCH_CENTRE_SUCCESS: {
      const centre = Object.assign({}, action.payload, { id: action.centreId });
      return state.set(action.centreId, new Centre(centre));
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/Centre/reducer.js